import { render, staticRenderFns } from "./Principal.vue?vue&type=template&id=722c9c7c"
import script from "./Principal.vue?vue&type=script&lang=js"
export * from "./Principal.vue?vue&type=script&lang=js"
import style0 from "./Principal.vue?vue&type=style&index=0&id=722c9c7c&prod&lang=css"
import style1 from "./Principal.vue?vue&type=style&index=1&id=722c9c7c&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports